module.exports = __webpack_public_path__ + "static/media/navbar-ico-4-active.6ea2b620.svg";